/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Empty } from '../../models/empty';
import { UbereatsStoreProvisionRequest } from '../../models/ubereats-store-provision-request';

export interface UbereatsStoreProvisionAggregatorStoreIdPost$Params {
  'Active-Tenant-Identifier': string;
  aggregatorStoreId: string;
      body: UbereatsStoreProvisionRequest
}

export function ubereatsStoreProvisionAggregatorStoreIdPost(http: HttpClient, rootUrl: string, params: UbereatsStoreProvisionAggregatorStoreIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
  const rb = new RequestBuilder(rootUrl, ubereatsStoreProvisionAggregatorStoreIdPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('aggregatorStoreId', params.aggregatorStoreId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Empty>;
    })
  );
}

ubereatsStoreProvisionAggregatorStoreIdPost.PATH = '/ubereats/storeProvision/{aggregatorStoreId}';
